import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { connect as connectStaticText } from '../StaticText/connect'
import { TARGET_BLANK } from '../Link/index'
import Button, { TYPES } from '../Button/index'
import { ICON_TYPES } from '../Icon.v2/index'
import { H3 } from '../Heading/index'
import { getPrimary } from '../../services/languages/index'
import {
  getHelpCenterUrl,
} from '../../services/url/index'

const Support = (props) => {
  const { staticText, userLanguage } = props
  const userPrimaryLanguage = getPrimary(userLanguage)
  return (
    <div className="support">
      <H3 inverted>{ staticText.getIn(['data', 'title']) }</H3>
      <div className="support__body">
        { staticText.getIn(['data', 'body']) } <br /><br />
        { staticText.getIn(['data', 'spain']) }<br />
        { staticText.getIn(['data', 'mexico']) }
      </div>
      <div className="support__container">
        <div className="support__button-container">
          <div className="support__button-cell">
            <Button
              type={TYPES.ICON}
              icon={ICON_TYPES.COMMENT}
              url={getHelpCenterUrl(userPrimaryLanguage)}
              className="support__button"
              rel="nofollow"
              target={TARGET_BLANK}
              directLink
              stacked
            >
              {staticText.getIn(['data', 'supportCenter'])}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

Support.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  userLanguage: ImmutablePropTypes.list.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'support' }),
  connectRedux(
    (state) => ({
      userLanguage: state.user.getIn(['data', 'language'], List()),
    }),
  ),
)(Support)
